import { Flex } from "@chakra-ui/react"

export const UserDetailItemLabel = ({ children }: { children: React.ReactNode }) => {
  return <Flex sx={{ gap: 2, flexWrap: 'nowrap' }}>{children}</Flex>
}

export const UserDetailItemValue = ({ children }: { children: React.ReactNode }) => {
  return <Flex sx={{ gap: 2, flexWrap: 'wrap', fontWeight: 'medium' }}>{children}</Flex>
}
